const AuthTypes = {
  SET_AUTH_DATA: "SET_AUTH_DATA",

  LOADING_START: "LOADING_START",
  LOADING_STOP: "LOADING_STOP",

  SIGN_IN_REQUEST: "SIGN_IN_REQUEST",
  SIGN_IN_SUCCESS: "SIGN_IN_SUCCESS",
  SIGN_IN_FAILURE: "SIGN_IN_FAILURE",

  SIGN_OUT_REQUEST: "SIGN_OUT_REQUEST",
  SIGN_OUT_SUCCESS: "SIGN_OUT_SUCCESS",
  SIGN_OUT_FAILURE: "SIGN_OUT_FAILURE",

  REGISTER_REQUEST: "REGISTER_REQUEST",
  REGISTER_SUCCESS: "REGISTER_SUCCESS",
  REGISTER_FAILURE: "REGISTER_FAILURE",

  REGISTER_INITIATE_REQUEST: "REGISTER_INITIATE_REQUEST",
  REGISTER_INITIATE_SUCCESS: "REGISTER_INITIATE_SUCCESS",
  REGISTER_INITIATE_FAILURE: "REGISTER_INITIATE_FAILURE",

  REGISTER_COMPLETE_REQUEST: "REGISTER_COMPLETE_REQUEST",
  REGISTER_COMPLETE_SUCCESS: "REGISTER_COMPLETE_SUCCESS",
  REGISTER_COMPLETE_FAILURE: "REGISTER_COMPLETE_FAILURE",

  RESET_AUTH_STATE: "RESET_AUTH_STATE",


};

export default AuthTypes;
